var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.9c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-4.47l-.13 1.21-2.2 4.94c-.2.5-.73.85-1.34.85H6.5c-.8 0-1.5-.73-1.5-1.5V5.9c0-.39.16-.74.43-1L9.63 0l.77.74c.2.19.32.45.32.74l-.03.22L9 4.9h10m-19 9v-8h3v8H0z",
    fill: "#C1CEDE",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.01f9269f99cc56a9ce1fddf129d7f98a.svg";
export { ForwardRef as ReactComponent };